<app-dialog-base [showLoadingSpinner]="uiState === uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>Add New FAQ</span>

  @if (uiState === uiStateEnumForTemplate.ShowData) {
    <ng-container dialog-content>
      <form cForm [formGroup]="addFaqForm" novalidate>
        <div class="mb-3 position-relative">
          <label cLabel for="questionInput">Question</label>
          <input cFormControl
                 [valid]="questionControl.touched && questionControl.valid ? true : questionControl.touched && questionControl.invalid ? false : undefined"
                 formControlName="question"
                 id="questionInput"
                 data-testid="add-faq-question-input"
                 placeholder="enter a question you want to provide an answer to"
          />

          @if (questionControl.invalid && questionControl.touched) {
            <c-form-feedback [valid]="false" tooltip>
              <div data-testid="add-faq-question-required-error">question is required</div>
            </c-form-feedback>
          }
        </div>

        <div class="mb-3 position-relative">
          <label cLabel for="answerInput">Answer (markdown)</label>
          <textarea cFormControl
                    [valid]="answerContentControl.touched && answerContentControl.valid ? true : answerContentControl.touched && answerContentControl.invalid ? false: undefined"
                    formControlName="answer"
                    placeholder="enter your markdown answer here"
                    id="answerInput"
                    data-testid="add-faq-answer-input"
                    rows="8"></textarea>
          @if (answerContentControl.invalid && answerContentControl.touched && answerContentControl.errors) {
            <c-form-feedback [valid]="false" tooltip>
              <div data-testid="add-faq-answer-required-error">answer is required</div>
            </c-form-feedback>
          }
        </div>

        <div class="mb-3 position-relative">
          <label cLabel for="scopeTypeSelect">FAQ Scope</label>
          <select
            cFormControl
            class="form-select"
            formControlName="scopeType"
            id="scopeTypeSelect"
            data-testid="add-faq-scope-type-select"
          >
            @for (scope of availableScopes; track scope.value) {
              <option [value]="scope.value">{{ scope.label }}</option>
            }
          </select>
        </div>

        <div class="mb-3 position-relative">
          <c-form-check [switch]="true" [sizing]="'xl'">
            <input cFormCheckInput type="checkbox" data-testid="add-faq-shared-toggle" formControlName="shared"/>
            <label cFormCheckLabel>Shared FAQ (available to all games)</label>
          </c-form-check>
        </div>

        @if (!sharedControl.value) {
          <div class="mb-3">
            <label cLabel class="mb-2">Select Games</label>
            <app-faq-game-selector [initialSelectedGameIds]="initialSelectedGameIds()"></app-faq-game-selector>
          </div>
        }

        <div class="d-grid gap-2 mb-3">
          <button cButton color="primary" [cModalToggle]="verticallyCenteredModal.id" data-testid="add-faq-preview-button">Preview Answer</button>
        </div>

        <div class="mb-3 position-relative">
          <c-form-check [switch]="true" [sizing]="'xl'">
            <input cFormCheckInput type="checkbox" data-testid="add-faq-active-toggle" formControlName="active"/>
            <label cFormCheckLabel>Should this FAQ be active?</label>
          </c-form-check>
        </div>

        <c-modal #verticallyCenteredModal alignment="center" id="verticallyCenteredModal" [backdrop]="false">
          <c-modal-header>
            <h5 cModalTitle data-testid="add-faq-preview-header">{{questionControl.value}}</h5>
            <button [cModalToggle]="verticallyCenteredModal.id" cButtonClose></button>
          </c-modal-header>
          <c-modal-body>
            <markdown [data]="answerContentControl.getRawValue()" data-testid="add-faq-preview-content"></markdown>
          </c-modal-body>
          <c-modal-footer>
            <button [cModalToggle]="verticallyCenteredModal.id" cButton color="secondary" data-testid="add-faq-preview-close-button">
              Close
            </button>
          </c-modal-footer>
        </c-modal>

        @if(!activeControl.value) {
          <div class="mt-3 p-3 rounded border-start border-warning border-3 bg-warning bg-opacity-10">
            <div class="text-warning fw-medium" data-testid="add-faq-inactive-message">**Note: This faq is not active. It will not appear in the web app until "Should this FAQ
              to active?" is toggled to the on position.
            </div>
          </div>
        }

      </form>
    </ng-container>
  }

  <ng-container actions>
    <button mat-button
            (click)="addFaq()"
            data-testid="finalize-add-faq"
            [disabled]="uiState === uiStateEnumForTemplate.ShowLoading">
      Add
    </button>
  </ng-container>
</app-dialog-base>
